module.exports = __webpack_public_path__ + "img/icon.3708d533.png";